@if (!editMode) {
  <div>
    <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mb-2">
      <div class="tw:w-full tw:px-[15px] tw:mb-12">
        <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:my-2">
          <div class="tw:w-auto tw:px-[15px]">
            <div class="kvp__k tw:py-1">Assessment Score:</div>
          </div>
          <div class="tw:flex-1 tw:px-[15px]">
            <div class="kvp__v tw:py-1">{{ timelineSection.assessmentScorePercentage }} % &nbsp;</div>
          </div>
        </div>
      </div>
      <div class="tw:w-full tw:px-[15px] tw:lg:w-1/2 tw:mb-12">
        <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:my-2">
          <div class="tw:w-auto tw:px-[15px]">
            <div class="kvp__k tw:py-1">Initial Key Stage:</div>
            <div class="kvp__k tw:py-1">Initial Learning Band:</div>
          </div>
          <div class="tw:flex-1 tw:px-[15px]">
            <div class="kvp__v tw:py-1">{{ initialKeyStageText }} &nbsp;</div>
            <div class="kvp__v tw:py-1">{{ initialLearningBandText }} &nbsp;</div>
          </div>
        </div>
      </div>
      <div class="tw:w-full tw:px-[15px]">
        <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mb-12">
          <div class="tw:flex-1 tw:px-[15px]">
            <div class="kvp kvp--stacked">
              <div class="kvp__k kvp__k--heading">Comments On Initial Assessment:</div>
              <div class="kvp__v kvp__v--long-text">
                {{ timelineSection.tutorInitialAssessment }}
              </div>
            </div>
          </div>
        </div>
        <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mb-12">
          <div class="tw:flex-1 tw:px-[15px]">
            <div class="kvp kvp--stacked">
              <div class="kvp__k kvp__k--heading">Comments From Tuition Programme Brief:</div>
              <div class="kvp__v kvp__v--long-text">
                {{ timelineSection.individualLearningPlan }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="tw:w-full tw:px-[15px] tw:lg:w-1/2 tw:mb-12">
        <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:my-2">
          <div class="tw:w-auto tw:px-[15px]">
            <div class="kvp__k tw:py-1">Target Key Stage:</div>
            <div class="kvp__k tw:py-1">Target Learning Band:</div>
          </div>
          <div class="tw:flex-1 tw:px-[15px]">
            <div class="kvp__v tw:py-1">{{ targetKeyStageText }} &nbsp;</div>
            <div class="kvp__v tw:py-1">{{ targetLearningBandText }} &nbsp;</div>
          </div>
        </div>
      </div>
      <div class="tw:w-full tw:px-[15px]">
        <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mb-12">
          <div class="tw:flex-1 tw:px-[15px]">
            <div class="kvp kvp--stacked">
              <div class="kvp__k kvp__k--heading">Plan To Achieve Target:</div>
              <div class="kvp__v kvp__v--long-text">
                {{ timelineSection.targetDescription }}
              </div>
            </div>
          </div>
        </div>
        <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mb-4">
          <div class="tw:flex-1 tw:px-[15px]">
            <div class="kvp kvp--stacked">
              <div class="kvp__k kvp__k--heading">Learner Comments:</div>
              <div class="kvp__v kvp__v--long-text">
                {{ timelineSection.learnerComments }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
